import { render, staticRenderFns } from "./WorkflowHistory.vue?vue&type=template&id=6934fa57&"
import script from "./WorkflowHistory.vue?vue&type=script&lang=js&"
export * from "./WorkflowHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports